import { type ContentColumnReadContent } from '../content-column-read.ts';

export type PageLabelsReadContent = ContentColumnReadContent<'page-labels'>;
export const EMPTY_PAGE_LABELS_CONTENT: PageLabelsReadContent = Object.freeze({
  kind: 'page-labels',
  loadingWidth: 0,
  openLinksInNewTab: false,
  items: Object.freeze([])
});
